export const CONTACT = {
  email: "sundeepa.bamval@gmail.com",
  whatsapp: "+91 98739 05279",
  whatsappLink: "https://wa.me/919873905279",
  linkedin: "https://www.linkedin.com/in/sundeepa-bamval-mandal-17772261/",
  location: "New Delhi, India — working globally",
};

export const PORTRAIT =
  "https://static.wixstatic.com/media/50adaf_a48787d130fe412b9d9c82a402971768~mv2.jpg";

export const BRANDS = [
  "Zara", "H&M", "ITC Wills Lifestyle", "FableStreet", "Chico's", "Weekday",
  "H&M Studio", "H&M Conscious",
];

export const SERVICES = [
  {
    id: "strategy",
    icon: "layers",
    title: "Product & Collection Strategy",
    tagline: "SKU rationalisation & pricing tier architecture",
    problem: "Too many SKUs, low sales per style, wrong product mix for your target consumers.",
    solution: "A clear product roadmap aligning collections with consumers, D2C/marketplace channels and strict profitability goals.",
  },
  {
    id: "team",
    icon: "refresh",
    title: "Design Team Transformation",
    tagline: "Global workflows for Indian design teams",
    problem: "Teams working without clear systems, producing inconsistent collections.",
    solution: "Zara and H&M standard workflows — designers, merchandisers, marketing and sales finally moving as one.",
  },
  {
    id: "trend",
    icon: "trending",
    title: "Trend Forecasting for India",
    tagline: "Macro & micro trends through India's cultural lens",
    problem: "High dead inventory from blindly adopting Western global trendbooks.",
    solution: "Decoding Tier 1, 2 & 3 markets through festivals, climate, crafts and ethnic-wear demand — adapting global trends into Indian design language.",
  },
  {
    id: "calendar",
    icon: "calendar",
    title: "Collection Planning & Calendar Mastery",
    tagline: "Eliminate delays, maximise seasonal drops",
    problem: "Missed festival and wedding-season sales, factory overload and 4-6 week delays.",
    solution: "Advance fashion calendars aligning design drops with factory capacity — converting chaos into predictable revenue growth.",
  },
  {
    id: "print",
    icon: "brush",
    title: "Print Directions + CAD Development",
    tagline: "Seamless repeats & vendor-ready tech packs",
    problem: "High sampling costs caused by unclear print development.",
    solution: "From theme development to digital strike-offs: Illustrator files, 3D placement renders and vendor-ready tech packs.",
  },
  {
    id: "colour",
    icon: "palette",
    title: "Indian Fashion Colour Trend-Book",
    tagline: "India's first skin-tone & festival colour system",
    problem: "Unsold inventory caused by Pantone palettes unsuited to Indian skin tones and occasions.",
    solution: "A seasonal colour guide curated for Indian skin tones, climate, festivals, weddings and regional preferences.",
  },
];

export const STATS = [
  { value: "10", label: "Years in Zara & H&M product development" },
  { value: "₹50 Cr", label: "Funding raised by FableStreet under her creative direction" },
  { value: "Tier 1-3", label: "Indian markets decoded for trend & colour" },
];

export const PORTFOLIO = [
  {
    brand: "Zara",
    category: "Zara",
    title: "Product Development",
    desc: "Leading product development for one of the world's fastest fashion machines.",
    meta: "Product Development · Zara & H&M · 10 years combined",
    img: "https://images.pexels.com/photos/36731322/pexels-photo-36731322.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=940",
    story: {
      challenge: "Move collections at fast-fashion speed without losing Indian manufacturing realities — coordinating fabrics, fits and finishes across a vast vendor base, season after season.",
      approach: "Led product development end-to-end: tech packs, sampling rounds, fabric and trim coordination with vendors, and fit sign-offs — translating design intent into production-ready specifications at a global fast-fashion rhythm.",
      outcome: "A decade of product development across Zara and H&M — a depth of fast-fashion production experience that makes her a rare bridge between international standards and Indian supply chains.",
    },
    gallery: [
      "https://images.unsplash.com/photo-1580682312385-e94d8de1cf3c?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.pexels.com/photos/236748/pexels-photo-236748.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.pexels.com/photos/8030173/pexels-photo-8030173.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    services: ["Product & Collection Strategy", "Design Team Transformation"],
  },
  {
    brand: "H&M",
    category: "H&M",
    title: "Product Development & Production",
    desc: "A decade of product development and production leadership across H&M Group.",
    meta: "Product Development & Production · H&M Group · 10 years combined",
    img: "https://images.unsplash.com/photo-1753164597585-6d42636ea099?crop=entropy&cs=srgb&fm=jpg&q=85",
    story: {
      challenge: "Support buying teams and production offices with collections that actually sell — balancing trend relevance, quality and landed cost across markets.",
      approach: "Worked as the bridge between design intent and production reality: converting trend insights into market-ready styles, developing vendors, and holding quality benchmarks across categories.",
      outcome: "Trusted across H&M Group markets — from Lifestyle Brands supply-chain leadership to Weekday production heads, her colleagues describe trend-to-product conversion as her signature strength.",
    },
    gallery: [
      "https://images.unsplash.com/photo-1551232864-3f0890e580d9?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1758269664127-1f744a56e06c?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1783070610671-1cc98dffba42?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
    services: ["Product & Collection Strategy", "Collection Planning & Calendar Mastery"],
  },
  {
    brand: "FableStreet",
    category: "FableStreet",
    title: "Creative Director",
    desc: "Creative head of the Indian womenswear brand — design direction that helped secure ₹50 Cr in funding.",
    meta: "Creative Director · FableStreet · Indian womenswear",
    img: "https://images.unsplash.com/photo-1613909671501-f9678ffc1d33?crop=entropy&cs=srgb&fm=jpg&q=85",
    story: {
      challenge: "Give a young Indian womenswear brand a design language sharp enough to win consumers — and investors.",
      approach: "Directed the brand's full design identity — collections, prints and product character — built on her India-focused trend forecasting and colour systems, with the intent of making every drop feel unmistakably FableStreet.",
      outcome: "Her design direction helped FableStreet secure ₹50 Cr in funding — proof that design, done properly, carries business momentum.",
    },
    gallery: [
      "https://images.unsplash.com/photo-1662532577856-31b1a6c9b3f8?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1613909671501-f9678ffc1d33?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1603189343302-e0b1b0e0f3f3?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
    services: ["Trend Forecasting for India", "Indian Fashion Colour Trend-Book"],
  },
  {
    brand: "H&M Conscious",
    category: "H&M",
    title: "Conscious Collections",
    desc: "Sustainable collection development for H&M's Conscious line.",
    meta: "Sustainable Collections · H&M Conscious",
    img: "https://images.unsplash.com/photo-1601056639638-c53c50e13ead?crop=entropy&cs=srgb&fm=jpg&q=85",
    story: {
      challenge: "Build sustainable lines that don't compromise on design desirability or commercial price points.",
      approach: "Developed Conscious collection styles with certified materials, carrying sustainability requirements through the full product development cycle — from fabric selection to vendor sign-offs.",
      outcome: "Sustainable collections that met H&M's global standards while staying commercially sharp for the market.",
    },
    gallery: [
      "https://images.unsplash.com/photo-1601056639638-c53c50e13ead?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.pexels.com/photos/31778601/pexels-photo-31778601.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1580682312385-e94d8de1cf3c?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
    services: ["Product & Collection Strategy", "Print Directions + CAD Development"],
  },
  {
    brand: "ITC Wills Lifestyle",
    category: "ITC & Wills",
    title: "Design Head",
    desc: "Heading design for one of India's most recognised premium lifestyle brands.",
    meta: "Design Head · ITC · Wills Lifestyle",
    img: "https://images.unsplash.com/photo-1557777586-f6682739fcf3?crop=entropy&cs=srgb&fm=jpg&q=85",
    story: {
      challenge: "Head design for one of India's most recognised premium lifestyle brands — and keep a full design team pulling in one direction.",
      approach: "Led the design team and seasonal collections for Wills Lifestyle: collection planning, print directions and the team workflows that turned briefs into store-ready ranges.",
      outcome: "The design-leadership foundation she now brings to consulting clients — Indian teams, organised the way global leaders run.",
    },
    gallery: [
      "https://images.unsplash.com/photo-1557777586-f6682739fcf3?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1753164597585-6d42636ea099?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.pexels.com/photos/37471992/pexels-photo-37471992.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    services: ["Design Team Transformation", "Collection Planning & Calendar Mastery"],
  },
  {
    brand: "Colour Trend-Book",
    category: "FableStreet",
    title: "India Colour Intelligence",
    desc: "India's first seasonal colour system built for Indian skin tones, festivals and climate.",
    meta: "Research & IP · Indian Fashion Colour Trend-Book",
    img: "https://images.unsplash.com/photo-1581079948988-537795b40f5f?crop=entropy&cs=srgb&fm=jpg&q=85",
    story: {
      challenge: "Global colour systems like Pantone aren't built for Indian skin tones, climate, festivals or regional preferences — and brands pay for that gap in unsold inventory.",
      approach: "Curated a seasonal colour guide decoding Tier 1, 2 and 3 Indian markets through festivals, climate, crafts and ethnic-wear demand.",
      outcome: "India's first fashion colour trend-book — now a core advisory tool across her brand engagements.",
    },
    gallery: [
      "https://images.unsplash.com/photo-1581079948988-537795b40f5f?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.pexels.com/photos/33830662/pexels-photo-33830662.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1624516268152-709d372ef2e8?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
    services: ["Indian Fashion Colour Trend-Book", "Trend Forecasting for India"],
  },
];

export const PORTFOLIO_FILTERS = ["All", "Zara", "H&M", "FableStreet", "ITC & Wills"];

export const CONSULTATION_RATE = {
  name: "Online Consultation",
  price: "₹7,000",
  unit: "per hour",
  desc: "One-on-one video consultation with Sundeepa — collection reviews, SKU and pricing debates, calendar planning, trend and colour direction, or vendor strategy.",
  features: [
    "Live 1:1 session on video",
    "Honest, experience-backed direction",
    "Written action notes after every session",
    "Book by the hour from the calendar",
  ],
};

export const PRICING = [
  {
    name: "Strategic Discovery",
    period: "1-day intensive",
    desc: "A deep-dive audit of your current collection, SKU performance and calendar bottlenecks.",
    features: [
      "3-hour strategy workshop",
      "SKU & pricing audit report",
      "Indian market colour direction",
      "14-day action roadmap",
    ],
  },
  {
    name: "Seasonal Collection Advisory",
    period: "3-month engagement",
    popular: true,
    desc: "Complete end-to-end collection direction, from moodboard to production-ready tech packs.",
    features: [
      "Collection concept & moodboards",
      "Custom print & CAD repeats",
      "Fashion calendar & drop schedule",
      "Design team mentorship",
      "Vendor tech-pack handoff",
    ],
  },
  {
    name: "Enterprise Transformation",
    period: "annual retainer",
    desc: "A full retainer engagement as fractional Creative Director for retail chains and apparel leaders.",
    features: [
      "Fractional Creative Director role",
      "Design function restructuring",
      "Executive board strategy",
      "Indian & global trendbooks",
      "Supply chain & factory sync",
    ],
  },
];

export const TESTIMONIALS = [
  {
    quote: "Sundeepa excels in fashion product development, supporting buying teams and using trend insights to create market-ready collections. Her work consistently drives strong, relevant results for the brand.",
    author: "Manish Chawla",
    role: "Global Supply Chain Manager",
    company: "H&M Lifestyle Brands",
  },
  {
    quote: "Sundeepa is really passionate to her work and having great experience in the field of fashion. Positive approach, TEAM player and business driven approach towards to the growth of the organization. Her creativity and thought process is always out of the box. Detail oriented, her ability and understanding on converting trends to product is commendable.",
    author: "Selcan Ötegen",
    role: "Head of Production",
    company: "Weekday",
  },
  {
    quote: "The creativity and thinking out of the box are the important characteristic of Sundeepa. Her attentive focus to the customer need covering the fashion with the commerciality support her business centric skill. She is a definitive contributor to the design and purchasing team.",
    author: "Hande Diltemiz",
    role: "Production Market Expansion",
    company: "H&M Group",
  },
  {
    quote: "Sundeepa is really passionate to her work and having great experience in the field of fashion. Positive approach, TEAM player and business driven approach towards to the growth of the organization. Always full of positive energy to deal either within the team or with her stakeholders.",
    author: "Hari Kumar Nair",
    role: "Business Governance Manager",
    company: "H&M Hennes & Mauritz India",
  },
];

export const ASSESSMENT_STEPS = [
  { id: "segment", q: "Where does your brand sit today?" },
  { id: "sku", q: "How many styles do you launch per season, and how do they sell?" },
  { id: "trend", q: "How do you source trends and colour direction?" },
  { id: "calendar", q: "How disciplined is your fashion calendar?" },
  { id: "goal", q: "What is your #1 business goal right now?" },
];

export const SLOTS = ["10:00 AM", "11:30 AM", "02:00 PM", "04:00 PM", "05:30 PM"];

export const TOPICS = [
  "Product & Collection Strategy",
  "Design Team Transformation",
  "Trend Forecasting for India",
  "Collection Planning & Calendar",
  "Print Directions & CAD",
  "Indian Colour Trend-Book",
  "Something else",
];
